export const LEARNER_ERROR_MESSAGES: Record<string, string> = {
  LEARNER_CANNOT_BE_OWN_CONTRIBUTOR: 'LEARNER_CANNOT_BE_OWN_CONTRIBUTOR',
};

export const CONTRIBUTOR_ERROR_MESSAGES: Record<string, string> = {
  DUPLICATE_CONTRIBUTOR: 'DUPLICATE_CONTRIBUTOR',
};
